import React from 'react'
import CommonSurveyQuestionList from '../../../common/pages/secure/SurveyQuestionList'
import Config from '../../../Config'

class SurveyMediumQuestionList extends CommonSurveyQuestionList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.surveyQuestionSetting
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
    this.serveyCategory = 'medium'
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push(`/admin/survey_mediumquestion/add/${this.state.surveyQuestionSettingList.bigQuestions[0].id}`)
        break
      case 'edit':
        if (this.state.surveyQuestionSettingList.bigQuestions && this.state.surveyQuestionSettingList.bigQuestions.length > 0) {
          this.props.history.push(`/admin/survey_bigquestion/edit/${this.state.surveyQuestionSettingList.bigQuestions[0].id}`);
        } else {
          console.error('No bigQuestions available to edit.');
        }
        break
      case 'back':
        this.props.history.push('/admin/survey_bigquestion')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>アンケート設問設定<br />
                  <small>こちらからアンケートの設問を管理できます。</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                {this.state.surveyQuestionSettingList.bigQuestions && this.state.surveyQuestionSettingList.bigQuestions[0].createDateTime && (
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規の中設問を登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
                )}
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='大設問の編集' className='text-center kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit')}>
                    <i className='icon-edit icon-large' /><br /><span>大設問</span>
                  </a>
                </li>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                    <i className='icon-arrow-left icon-large' /><span>戻る</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SurveyMediumQuestionList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveyMediumQuestionList.js